
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/[state]/[slug]",
      function () {
        return require("private-next-pages/search/[state]/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/[state]/[slug]"])
      });
    }
  